export default "__VITE_ASSET__CJP8ad4I__"